/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { getNextBreakpoint } from '../../../styles/Grid/GridSizes';
import { buildImagePath } from '../../../utils/cloudinary';

function SourceTag({
  breakpoint,
  config,
  imageSrc,
  isClientLink,
  retinaConfig,
  useBlank,
}) {
  // Used when an error occures rendering the image
  const fallBackImage = '/~/media/Regus/Settings/Fallbacks/blank.gif';
  const image = buildImagePath(config, imageSrc, isClientLink);
  //const image_2x = buildImagePath(retinaConfig, imageSrc, isClientLink);
  const nextBreakpoint = getNextBreakpoint(breakpoint);

  return (
    <source
      key={breakpoint}
      media={`(min-width: ${breakpoint}px)${
        nextBreakpoint ? ' and (max-width: ' + nextBreakpoint + 'px)' : ''
      }`}
      //srcSet={useBlank ? fallBackImage : `${image} 1x, ${image_2x} 2x`}
      srcSet={useBlank ? fallBackImage : `${image}`}
    />
  );
}

SourceTag.propTypes = {
  breakpoint: PropTypes.string,
  config: PropTypes.string,
  imageSrc: PropTypes.string,
  isClientLink: PropTypes.bool,
  retinaConfig: PropTypes.string,
  useBlank: PropTypes.bool,
};

export default SourceTag;
